var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDatabase = function SvgDatabase(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.333 3.8V8m0-4.2c0 .994-2.388 1.8-5.334 1.8-2.945 0-5.333-.806-5.333-1.8m10.667 0c0-.994-2.388-1.8-5.334-1.8-2.945 0-5.333.806-5.333 1.8M13.333 8v4.088c0 1.056-2.388 1.912-5.334 1.912-2.945 0-5.333-.856-5.333-1.912V8m10.667 0c0 .994-2.388 1.8-5.334 1.8-2.945 0-5.333-.806-5.333-1.8m0 0V3.8m8 3.533h.007m-.007 4h.007"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDatabase);
export default ForwardRef;